import Image from 'next/image'
import React from 'react'
import { Center } from '../../bases/Center'
import { Absolute } from '../../bases/Absolute'
import { Clickable } from '../../bases/Clickable'
import IconChange from '@/public/images/iconChange.png'

export type Props = {
  userIconUrl: string
  userFrameUrl: string
  onClickEditIcon?: () => void
}

export const Layout: React.VFC<Props> = (props) => {
  return (
    <Center className="relative h-40 w-40">
      <Center className="relative h-40 w-40">
        <Absolute>
          <Center className="overflow-hidden rounded-full">
            <Image width={145} height={145} objectFit="contain" alt="user icon" src={props.userIconUrl} />
          </Center>
        </Absolute>
        <Image width={160} height={160} objectFit="contain" alt="user frame" src={props.userFrameUrl} />
      </Center>
      {props.onClickEditIcon && (
        <Absolute className="right-0.5 bottom-6 rounded-full bg-black">
          <Clickable onClick={props.onClickEditIcon}>
            <Image src={IconChange} objectFit="contain" width={32} height={32} alt="Edit Icon" />
          </Clickable>
        </Absolute>
      )}
    </Center>
  )
}
